export default {
    contract_templates: [],
    current_template: null,
    loading: false
};
